<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    v-loading="loading"
    label-width="120px"
    class="carpo-form demo-ruleForm"
  >
    <customDialog
      v-if="addTag"
      :title="$t('add_tag')"
      childClass="info_msg"
      :show="addTag"
      @show="addTag = $event"
      @confirmButn="submitTask('taskForm')"
    >
      <el-form
        status-icon
        :model="taskForm"
        :rules="rules"
        label-position="top"
        v-loading="tagLoadingForm"
        ref="taskForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <el-form-item
          :label="`${$t('FA_TITLE')}`"
          prop="fa_title"
          :rules="{
            required: true,
            message: $t('REQUIRED_FIELD', {
              type: $t('FA_TITLE'),
            }),
            trigger: 'blur',
          }"
        >
          <el-input
            type="text"
            v-model="taskForm.fa_title"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="`${$t('EN_TITLE')}`"
          prop="en_title"
          :rules="{
            required: true,
            message: $t('REQUIRED_FIELD', {
              type: $t('EN_TITLE'),
            }),
            trigger: 'blur',
          }"
        >
          <el-input
            type="text"
            v-model="taskForm.en_title"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
    </customDialog>

    <el-form-item
      :label="$t('VEHCILE_NAME')"
      prop="vehicle.id"
      v-loading="vehicleLoading"
      element-loading-spinner="el-icon-loading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.vehicle.id"
        clearable
        filterable
      >
        <el-option-group
          v-for="group in list"
          :key="group.id"
          :label="$i18n.locale == 'fa' ? group.fa_title : group.en_title"
        >
          <el-option
            v-for="item in group.vehicles"
            :key="item.id"
            :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
            :value="item.id"
          >
          </el-option>
        </el-option-group>
      </el-select>
    </el-form-item>

    <LicensePlate
      :disabled="ruleForm.disabled"
      :license_plate_3="ruleForm.license_plate_3"
      @licensePlate3="ruleForm.license_plate_3 = $event"
      :license_plate_4="ruleForm.license_plate_4"
      @licensePlate4="ruleForm.license_plate_4 = $event"
      :license_plate_letter="ruleForm.license_plate_letter"
      @licensePlateLetter="ruleForm.license_plate_letter = $event"
      :license_plate_1="ruleForm.license_plate_1"
      @licensePlate1="ruleForm.license_plate_1 = $event"
    />

    <el-form-item
      :label="$t('STATUS')"
      prop="status.id"
      class="mt-5 md:mt-0"
      v-loading="statusLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        filterable
        v-model="ruleForm.status.id"
      >
        <template slot="prefix">
          <StatusPrefix :status="ruleForm.status.id" :statusList="statusList" />
        </template>

        <el-option
          v-for="item in statusList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
          <div class="flex items-center">
            <span
              :style="`background-color:${item.color.code}`"
              class="mx-2 w-2 h-2 rounded-full border border-gray-200"
            ></span>
            <span>
              {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
            </span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      :label="$t('CURRENT_TOTAL_ODOMETER')"
      prop="odometer_during_add"
    >
      <el-input-number
        :disabled="ruleForm.disabled"
        v-model="ruleForm.odometer_during_add"
        :step="1000"
        :min="0"
      ></el-input-number>
    </el-form-item>

    <el-form-item
      :label="$t('OWNERSHIP')"
      prop="ownership.id"
      class="mt-5 md:mt-0"
      v-loading="ownerLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        filterable
        v-model="ruleForm.ownership.id"
      >
        <template slot="prefix">
          <StatusPrefix
            :status="ruleForm.ownership.id"
            :statusList="ownerList"
          />
        </template>

        <el-option
          v-for="item in ownerList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
          <div class="flex items-center">
            <span
              :style="`background-color:${item.color.code}`"
              class="mx-2 w-2 h-2 rounded-full"
            ></span>
            <span>
              {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
            </span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('PRODUCTION_YESR')" prop="production_year">
      <date-picker
        :disabled="ruleForm.disabled"
        class="el-input__inner"
        v-model="ruleForm.production_year"
        type="year"
        :locale="$i18n.locale"
        clearable
      />
    </el-form-item>

    <el-form-item
      :label="$t('COLOR')"
      prop="color"
      v-loading="colorLoading"
      element-loading-spinner="el-icon-loading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.color.id"
        clearable
        filterable
      >
        <template slot="prefix">
          <StatusPrefix
            index=""
            :status="ruleForm.color.id"
            :statusList="colorList"
          />
        </template>
        <el-option
          v-for="item in colorList"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
          <div class="flex items-center">
            <span
              :style="`background-color:${item.code}`"
              class="mx-2 w-2 h-2 rounded-full border border-gray-300"
            ></span>
            <span>
              {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
            </span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>

    <div class="flex flex-nowrap items-start justify-between">
      <el-form-item
        :label="`${$t('TAG')}`"
        prop="company_vehicle_tags"
        v-loading="carTagsLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          v-model="ruleForm.company_vehicle_tags"
          clearable
          multiple
          :collapse-tags="!ruleForm.disabled"
          filterable
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in carTags"
            :key="item.id"
            :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div
        class="
          cursor-pointer
          bg-green-600
          hover:bg-green-800
          w-8
          h-8
          rounded-md
          flex
          items-center
          justify-center
          mt-0.5
        "
        @click="addTag = !addTag"
      >
        <i class="el-icon-plus text-white font-medium"></i>
      </div>
    </div>

    <el-form-item
      class="col-span-full mt-8"
      :label="$t('description')"
      prop="description"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="textarea"
        v-model="ruleForm.description"
      ></el-input>
    </el-form-item>

    <FormConfirmation
      :loading="submitLoading"
      v-if="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import {
  addCar,
  editCar,
  carStatus,
  carOwnership,
  carCabins,
  getCarsTag,
  addTag,
} from '@/api/cars'
import { carsList, colorList, licenseChars } from '@/api/global'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { reverseCurrency } from '@/mixins/reverseCurrency'
import StatusPrefix from '@/components/elements/statusPrefix'
import LicensePlate from '@/components/elements/LicensePlate'
import customDialog from '@/components/elements/dialog'

export default {
  mixins: [resetForm, jalaliToGregorian, reverseCurrency],
  props: {
    car: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    FormConfirmation,
    StatusPrefix,
    LicensePlate,
    customDialog,
  },
  data() {
    return {
      value: [],
      list: [],
      taskForm: {
        fa_title: '',
        en_title: '',
      },
      addTag: false,
      colorLoading: true,
      vehicleLoading: true,
      driverLoading: true,
      hardwareLoading: true,
      submitLoading: false,
      tagLoadingForm: false,
      statusLoading: true,
      carTags: [],
      carTagsLoading: true,
      ownerList: [
        {
          id: null,
          color: {
            id: 0,
            en_title: '',
            fa_title: '',
            code: '',
          },
          en_title: '',
          fa_title: '',
        },
      ],
      colorList: [],
      statusList: [
        {
          fa_title: '',
          color: {
            code: '',
          },
          en_title: '',
          id: null,
        },
      ],
      notUsedDrivers: [],
      imeiList: [],
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      ownerLoading: true,
      test: null,
      alphaLoading: true,
      ruleForm: {
        license_plate: '',
        company_vehicle_tags: [],
        ownership: {
          fa_title: '',
          color: {
            id: '',
          },

          en_title: '',
          id: null,
        },
        manufacturing_year: '',
        third_party_insurance_expiry_date: '',
        vehicle_insurance_expiry_date: '',
        vehicle_inspection_expiry_date: '',
        odometer_during_add: '',

        description: '',
        vehicle: {
          id: '',
        },
        status: {
          fa_title: '',
          color_code: '',
          en_title: '',
          id: null,
        },
        color: {
          id: '',
        },

        driver: {
          id: '',
        },
        device: {
          id: '',
        },
      },

      rules: {
        vehicle: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_FIELD', {
                type: this.$i18n.t('VEHCILE_NAME'),
              }),
              trigger: 'change',
            },
          ],
        },
        status: {
          id: [
            {
              required: false,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('STATUS'),
              }),
              trigger: 'change',
            },
          ],
        },
        ownership: {
          id: [
            {
              required: false,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('OWNERSHIP'),
              }),
              trigger: 'change',
            },
          ],
        },
        license_plate_4: [
          {
            required: true,
            trigger: 'blur',
            message: ' ',
          },
        ],
        license_plate_3: [
          {
            required: true,
            trigger: 'blur',
            message: ' ',
          },
        ],
        license_plate_1: [
          {
            required: true,
            trigger: 'blur',
            message: ' ',
          },
        ],
        license_plate_letter: [
          {
            required: true,
            trigger: 'blur',
            message: ' ',
          },
        ],
      },
    }
  },
  watch: {
    car(val) {
      this.ruleForm = val

      if (this.ruleForm.driver.id != '') {
        this.notUsedDrivers.push(this.ruleForm.driver)
      } else {
      }
      if (this.ruleForm.device.id != '')
        this.imeiList.push(this.ruleForm.device)
    },
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            production_year: this.ruleForm.production_year,
            third_party_insurance_expiry_date: this.jalaliToGregorian(
              this.ruleForm.third_party_insurance_expiry_date,
              this.$i18n.locale
            ),
            vehicle_inspection_expiry_date: this.jalaliToGregorian(
              this.ruleForm.vehicle_inspection_expiry_date,
              this.$i18n.locale
            ),
            vehicle_insurance_expiry_date: this.jalaliToGregorian(
              this.ruleForm.vehicle_insurance_expiry_date,
              this.$i18n.locale
            ),
            vehicle: this.ruleForm.vehicle.id,
            color: this.ruleForm.color.id,
            description: this.ruleForm.description,
            company_vehicle_tags: this.ruleForm.company_vehicle_tags,
            license_plate:
              this.ruleForm.license_plate_1 +
              this.ruleForm.license_plate_letter +
              this.ruleForm.license_plate_3 +
              this.ruleForm.license_plate_4,
            odometer_during_add: this.ruleForm.odometer_during_add * 1000,
            status: this.ruleForm.status.id,
            ownership: this.ruleForm.ownership.id,
            driver: this.ruleForm.driver.id,
            id: this.$route.params.id,
            device: this.ruleForm.device.id,
          }
          var dispatchFunc = this.car == null ? addCar : editCar
          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title: this.$t('BASIC_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
    submitTask(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            fa_title: this.taskForm.fa_title,
            en_title: this.taskForm.en_title,
          }
          this.tagLoadingForm = true
          addTag.api(actionPayload).then((res) => {
            this.tagLoadingForm = false
            if (res) {
              this.carTags.push({
                fa_title: res.fa_title,
                en_title: res.en_title,
                id: res.id,
              })
              this.ruleForm.company_vehicle_tags.push(res.id)

              this.addTag = false
            }
          })
        }
      })
    },
  },
  mounted() {
    if (this.car != null) {
      this.ruleForm = this.car
      // console.log(this.ruleForm)
      if (this.car.driver.id != '') {
        this.notUsedDrivers.push(this.ruleForm.driver)
      } else {
      }
      if (this.ruleForm.device.id != '')
        this.imeiList.push(this.ruleForm.device)
    }

    carsList.api().then((res) => {
      if (res) {
        this.vehicleLoading = false
        this.list = res
      }
    })
    colorList.api().then((res) => {
      if (res) {
        this.colorLoading = false
        this.colorList = res
      }
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
      this.alphaLoading = false
    })

    carStatus.api().then((res) => {
      if (res) {
        this.statusList = res
        this.statusLoading = false
      }
    })
    carOwnership.api().then((res) => {
      if (res) {
        this.ownerList = res
        this.ownerLoading = false
      }
    })
    getCarsTag.api().then((res) => {
      if (res) {
        this.carTags = res.sort((a, b) => {
          const nameA = a.fa_title?.toLowerCase() || ''
          const nameB = b.fa_title?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        this.carTagsLoading = false
      }
    })

    carCabins.api().then((res) => {
      if (res) {
        this.cabins = res
        this.cabinLoading = false
      }
    })
  },
}
</script>
